import React, { useEffect, useRef, useState } from 'react'
import {
  FaTimes,
  FaPlus,
  FaChevronDown,
  FaCheck,
  FaExclamation,
} from 'react-icons/fa'
import { Outlines } from '../../types/presentationView'
import axios from 'axios'
import { toast } from 'react-toastify'
import { PricingModal } from '../shared/PricingModal'
import GuidedTourOutlineMobile from '../onboarding/shared/GuidedTourOutlineMobile'
import { Theme } from '../../lib/theme';
interface MobileOutlineDropdownProps {
  outlines: Outlines[]
  onSelectOutline: (outlineid: string) => void
  selectedOutline: string
  documentID: string
  selectedOutlineID: string
  fetchOutlines: () => Promise<void>
  isLoading: boolean
  subscriptionId: string
  userPlan: string // Plan types
  monthlyPlanAmount: number
  yearlyPlanAmount: number
  currency: string
  yearlyPlanId: string
  monthlyPlanId: string
  authToken: string
  orgId: string
  isNewSlideLoading: {
    [key: string]: boolean
  }
  newSlideGenerated: { [key: string]: string }
}

export default function MobileOutlineModal({
  outlines,
  onSelectOutline,
  selectedOutline,
  documentID,
  fetchOutlines,
  selectedOutlineID,
  isLoading,
  userPlan,
  monthlyPlanAmount,
  yearlyPlanAmount,
  currency,
  yearlyPlanId,
  monthlyPlanId,
  orgId,
  newSlideGenerated,
  subscriptionId,
  isNewSlideLoading,
}: MobileOutlineDropdownProps) {
  const [isOutlinesOpen, setIsOutlinesOpen] = useState(false)
  const [isAddSlideModalOpen, setIsAddSlideModalOpen] = useState(false)
  const [newSlideTitle, setNewSlideTitle] = useState('')
  const [newSlidePosition, setNewSlidePosition] = useState('')
  const authToken = sessionStorage.getItem('authToken')
  const [isAddingSlide, setIsAddingSlide] = useState(false)
  const [isPricingModalOpen, setIsPricingModalOpen] = useState(false)
  const buttonRef = useRef<HTMLDivElement | null>(null)

  const generateOutlineID = () => {
    return `outlineID-${window.crypto.randomUUID()}`
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {}

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const handleAddSlide = async () => {
    const newOutlineID = generateOutlineID()
    setIsAddingSlide(true)
    if (newSlideTitle && newSlidePosition) {
      const outlineIndex = Number(newSlidePosition) - 1
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/outline/blocklist/insert`,
        {
          documentId: documentID,
          title: newSlideTitle,
          position: Number(outlineIndex),
          outlineID: `outlineID-${window.crypto.randomUUID()}`,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      )
      const result = response.data
      if (result.type && result.title) {
        // Retrieve the existing outlineIDs array from sessionStorage
        const storedOutlineIDs = sessionStorage.getItem('outlineIDs')
        let outlineIDs = storedOutlineIDs ? JSON.parse(storedOutlineIDs) : []

        // Add the new outlineID to the array
        outlineIDs.push(newOutlineID)

        // Save the updated array back to sessionStorage
        sessionStorage.setItem('outlineIDs', JSON.stringify(outlineIDs))

        setIsAddSlideModalOpen(false)
        toast.success('Outline Added', {
          position: 'top-right',
          autoClose: 3000,
        })
        setIsAddingSlide(false)
        fetchOutlines()
      }
    }
  }

  return (
    <div>
      {/* Dropdown Button */}
 
<div
  id="dropdown-mobile"
  className="w-full rounded-lg p-3 lg:p-4 cursor-pointer"
  onClick={() => setIsOutlinesOpen(true)}
  style={{
    border: `1px solid ${Theme.colors.stroke.weak}`,
    backgroundColor: Theme.colors.background,
    color: Theme.colors.text.strong,
  }}
>
        {isLoading ? (
     <div className="w-full h-full flex items-center justify-center">
     <div
       className="w-10 h-10 border-4 rounded-full animate-spin"
       style={{
         borderTopColor: Theme.colors.info, // or primary
         borderColor: Theme.colors.stroke.weak,
       }}
     ></div>
   </div>
        ) : (
          <div className="flex items-center justify-between">
          <span style={{ color: Theme.colors.text.strong }} className="flex items-center">
            <span>{selectedOutline || 'Select Outline'}</span>
            <span>
              {isNewSlideLoading[selectedOutlineID] && (
                <div className="flex items-center justify-center ml-4 mt-1">
                  <div
                    className="w-4 h-4 border-4 rounded-full animate-spin"
                    style={{
                      borderTopColor: Theme.colors.info,
                      borderColor: Theme.colors.stroke.weak,
                    }}
                  ></div>
                </div>
              )}
              {newSlideGenerated[selectedOutlineID] === 'Yes' &&
                !isNewSlideLoading[selectedOutlineID] && (
                  <div className="flex items-center justify-center ml-4 mb-1">
                    <div className="w-3 h-3">
                      <FaCheck style={{ color: Theme.colors.success }} />
                    </div>
                  </div>
                )}
              {newSlideGenerated[selectedOutlineID] === 'No' &&
                !isNewSlideLoading[selectedOutlineID] && (
                  <div className="flex items-center justify-center ml-4 mb-1">
                    <div className="w-3 h-3">
                      <FaExclamation style={{ color: Theme.colors.error }} />
                    </div>
                  </div>
                )}
            </span>
          </span>
        
          <span>
            <FaChevronDown style={{ color: Theme.colors.text.weak }} className="ml-2" />
          </span>
        </div>
        )}
      </div>

      {/* Full-Screen Outlines List */}
      {isOutlinesOpen && (
    <div
    className="overflow-y-auto scrollbar-none fixed inset-0 z-50 p-4"
    style={{ backgroundColor: Theme.colors.background }}
  >
    {/* Header */}
    <div className="flex justify-between items-center mt-5 mb-5">
      <h2
        className="text-lg font-semibold"
        style={{ color: Theme.colors.text.strong }}
      >
        Outline
      </h2>
      <div className="flex items-center gap-4">
        <button
          onClick={() => setIsOutlinesOpen(false)}
          className="text-sm px-3 py-1 rounded-md hover:underline"
          style={{
            border: `1px solid ${Theme.colors.stroke.strong}`,
            color: Theme.colors.text.weak,
          }}
        >
          Back
        </button>
        <div ref={buttonRef} className="relative inline-block">
          <button
            id="outline-mobile"
            className="text-sm px-2 py-2 rounded-md hover:underline"
            style={{
              border: `1px solid ${Theme.colors.primary}`,
              color: Theme.colors.primary,
            }}
            onClick={() => setIsAddSlideModalOpen(true)}
          >
            <FaPlus />
          </button>
        </div>
      </div>
    </div>
  
    {/* Outlines List */}
    <div className="h-dvh">
      <ul className="space-y-2">
        {outlines.map((outline, index) => (
          <li
            key={index}
            className="py-2 font-medium flex items-center justify-between cursor-pointer"
            style={{ color: Theme.colors.text.strong }}
            onClick={() => {
              onSelectOutline(outline.outlineID);
              setIsOutlinesOpen(false);
            }}
          >
            <span>
              {index + 1}. {outline.title}
            </span>
            <span>
              {isNewSlideLoading[outline.outlineID] && (
                <div className="flex items-center justify-center ml-2 mt-1">
                  <div
                    className="w-6 h-6 border-4 rounded-full animate-spin"
                    style={{
                      borderTopColor: Theme.colors.info,
                      borderColor: Theme.colors.stroke.weak,
                    }}
                  />
                </div>
              )}
              {newSlideGenerated[outline.outlineID] === 'Yes' &&
                !isNewSlideLoading[outline.outlineID] && (
                  <div className="w-5 h-5">
                    <FaCheck style={{ color: Theme.colors.success }} />
                  </div>
                )}
              {newSlideGenerated[outline.outlineID] === 'No' &&
                !isNewSlideLoading[outline.outlineID] && (
                  <div className="w-5 h-5">
                    <FaExclamation style={{ color: Theme.colors.error }} />
                  </div>
                )}
            </span>
          </li>
        ))}
      </ul>
    </div>
  </div>
      )}

      {/* Add Slide Modal */}
      {isAddSlideModalOpen && (
        <div className="fixed inset-0 z-50 flex justify-center items-center">
  {/* Background */}
  <div
    className="absolute inset-0"
    style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    onClick={() => setIsAddSlideModalOpen(false)}
  ></div>

  {/* Modal Content */}
  <div
    className="relative w-11/12 md:w-1/2 lg:w-1/3 rounded-3xl shadow-lg p-6"
    style={{ backgroundColor: Theme.colors.background }}
  >
    {/* Close Icon */}
    <div
      className="absolute top-4 right-4 rounded-full p-2 cursor-pointer"
      style={{ backgroundColor: Theme.colors.stroke.weak }}
      onClick={() => setIsAddSlideModalOpen(false)}
    >
      <FaTimes style={{ color: Theme.colors.text.weak }} />
    </div>

    {/* Heading */}
    <h2
      className="text-xl text-center font-semibold"
      style={{ color: Theme.colors.text.strong }}
    >
      Add Slide
    </h2>

    {/* Input Fields */}
    <input
      type="text"
      placeholder="Enter Slide Title"
      className="w-full rounded-lg p-3 mt-4 border"
      style={{
        borderColor: Theme.colors.stroke.weak,
        color: Theme.colors.text.strong,
        backgroundColor: Theme.colors.background,
      }}
      value={newSlideTitle}
      onChange={(e) => setNewSlideTitle(e.target.value)}
    />
    <input
      type="number"
      placeholder="Enter Position Number"
      className="w-full rounded-lg p-3 mt-4 border"
      style={{
        borderColor: Theme.colors.stroke.weak,
        color: Theme.colors.text.strong,
        backgroundColor: Theme.colors.background,
      }}
      value={newSlidePosition}
      onChange={(e) => setNewSlidePosition(e.target.value)}
    />

    {/* Action Buttons */}
    {!isAddingSlide ? (
      <button
        onClick={handleAddSlide}
        disabled={!newSlideTitle || !newSlidePosition}
        className="w-full p-4 rounded-lg mt-4 transition"
        style={{
          backgroundColor:
            newSlideTitle && newSlidePosition
              ? Theme.colors.primary
              : Theme.colors.stroke.weak,
          color:
            newSlideTitle && newSlidePosition
              ? "#FFFFFF"
              : Theme.colors.text.weak,
          cursor:
            newSlideTitle && newSlidePosition ? "pointer" : "not-allowed",
        }}
      >
        Add Slide
      </button>
    ) : (
      <div className="w-full h-full flex items-center justify-center mt-4">
        <div
          className="w-6 h-6 border-4 rounded-full animate-spin"
          style={{
            borderTopColor: Theme.colors.primary,
            borderColor: Theme.colors.stroke.weak,
          }}
        ></div>
      </div>
    )}

    <button
      onClick={() => setIsAddSlideModalOpen(false)}
      className="w-full p-3 mt-2"
      style={{ color: Theme.colors.text.weak }}
    >
      Cancel
    </button>
  </div>
</div>
      )}
      {/* Pricing Modal */}
      {isPricingModalOpen && (
        <PricingModal
          closeModal={() => setIsPricingModalOpen(false)}
          heading="Subscription Plans"
          monthlyPlanAmount={monthlyPlanAmount}
          yearlyPlanAmount={yearlyPlanAmount}
          currency={currency!}
          yearlyPlanId={yearlyPlanId!}
          monthlyPlanId={monthlyPlanId!}
          authToken={authToken!}
          orgId={orgId!}
          subscriptionId={subscriptionId}
        />
      )}
      <GuidedTourOutlineMobile />
    </div>
  )
}
